/**
 * @file PageViewTracke
 */
import pageVisible from '@/pages/micro-detail/utils/pageVisibleEvent.js';
import {fetchNAParams} from '@baidu/map-fe-utils';

class PageViewTracker {
    constructor() {
        this.startTime = 0;
        // 最新上报的时间点
        this.preReportTime = 0;
        this.startView = false;
        // 埋点时长上报参数
        this.buryParams = {};
        // 干预开始和结束计时的业务逻辑检查函数
        this.checker = null;
        this.naInfo = null;
        this.commonParams = {};
        // 心跳埋点上报定时器
        this.heartbeatTimer = null;
        // 心跳上报次数，默认1次/秒
        this.heartBeatNum = 0;
        this.initParams();
    }

    // 初始化上报公共参数
    async initParams() {
        this.naInfo = await fetchNAParams();
        const {
            cuid = '',
            os = '',
            sv = '',
            mb = ''
        } = this.naInfo || {};
        this.commonParams = {
            cuid,
            os,
            sv,
            mb
        };
    }

    // 业务可以控制页面是否开始，比如页面初始化时，或者在某个事件触发后开始监控
    setChecker(checker) {
        if (typeof checker !== 'function') {
            return;
        }
        this.checker = checker;
    }

    // 发送日志
    sendLog(actionID, params) {
        if (!window.MapLogReport || !actionID) {
            console.warn('MapLogReport或actionID 不存在');
            return;
        }
        window.MapLogReport.send({
            da_src: actionID,
            ...params
        });
    }

    // 开始监控页面时长
    start(buryParams) {
        // 只需要注册一次离开和返回的处理函数
        if (!this.startView) {
            this.buryParams = buryParams;
            this.handleVisibilityChange();
        }
        // 如果有用户干预逻辑，且不满足开始条件，直接返回
        if (this.checker && typeof this.checker === 'function') {
            if (!this.checker()) {
                // 业务条件未满足，无法开始计时
                return;
            }
        }
        // 正常开始计时，初始化开始时间
        this.startTime = Date.now();
        this.preReportTime = this.startTime;
        // 上报开始埋点
        const param = {
            timestamp: this.startTime
        };
        const params = {...param, ...this.commonParams, ...this.buryParams};
        // 开始浏览时间上报
        this.sendLog('NewMedia.starttime.pt', params);
        // 已有心跳上报定时器，清除
        if (this.heartbeatTimer) {
            clearInterval(this.heartbeatTimer);
            this.heartbeatTimer = null;
        }
        // 心跳上报，间隔1秒再次上报
        this.heartbeatTimer = setInterval(() => {
            this.sendAnalytics();
        }, 1000);
    }

    // 心跳上报逻辑，上报当前时间戳和开始时间戳
    sendAnalytics(type = '') {
        // 心跳上报，上报次数
        this.heartBeatNum += 1;
        // 上报当前时间戳
        const timestamp = Date.now();
        const duration2 = timestamp - this.preReportTime;
        const param = {
            timestamp,
            start_timestamp: this.startTime,
            index: this.heartBeatNum,
            duration: 1000,
            // 真实时长
            duration2
        };
        const params = {...param, ...this.commonParams, ...this.buryParams};
        if (type === 'end') {
            params.duration = duration2;
        }
        this.sendLog('NewMedia.heartbeat.pt', params);
        // 每次心跳埋点上报以后更新下最新上报的时间点
        this.preReportTime = timestamp;
    }

    // 停止监控，手动调用可立即上报时长
    stop() {
        clearInterval(this.heartbeatTimer);
        this.heartbeatTimer = null;
        // 业务上已经stop的场景或者限制还未开始，遇到切后台等情况，不再次上报结束埋点
        if (this.startTime === 0) {
            return;
        }
        // 正常结束，上报时长埋点
        this.reportDuration();
        // 上报结束埋点
    }

    // 处理页面可视状态变化
    handleVisibilityChange() {
        this.startView = true;
        pageVisible.on('page-show', () => {
            if (this.checker && !this.checker()) {
                // 业务条件未满足，无法开始计时
                return;
            }
            this.start();
        });
        pageVisible.on('page-hide', () => {
            this.stop();
        });
    }

    // 计算并上报时长
    reportDuration() {
        const endTime = Date.now();
        const duration = endTime - this.startTime;
        if (this.startTime > 0) {
            const param = {
                starttime: this.startTime,
                endtime: endTime,
                duration
            };
            const params = {...param, ...this.commonParams, ...this.buryParams};

            // 浏览时长上报
            this.sendLog('NewMedia.newduration.pt', params);

            // 浏览结束时间上报
            const endParam = {
                timestamp: endTime,
                start_timestamp: this.startTime
            };
            const endParams = {...endParam, ...this.commonParams, ...this.buryParams};
            // 开始浏览时间上报
            this.sendLog('NewMedia.endtime.pt', endParams);
            this.sendAnalytics('end');
            // 结束后重置心跳上报次数
            this.heartBeatNum = 0;
        }
        this.startTime = 0;
    }
}

export default PageViewTracker;
